













































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, maxLength, requiredIf, ValidationRule } from 'vuelidate/lib/validators'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import POSController from '@/app/ui/controllers/POSController'
import PODController from '@/app/ui/controllers/PODTrackerController'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import MarketplaceTextInput from '../../components/MarketplaceTextInput/index.vue'
import MarketplaceDropdown from '../../components/MarketplaceDropdown/index.vue'
import ModalConfirm from '../../components/MarketplaceModal/ModalConfirm.vue'
import ModalAlreadyRegister from '../../components/MarketplaceModal/ModalAlreadyRegister.vue'
import ModalSuccess from '../../components/MarketplaceModal/ModalSuccess.vue'
import ModalCourierNotFound from '../../components/MarketplaceModal/ModalCourierNotFound.vue'
import { POS } from '@/domain/entities/POS'
import { LocalStorage, Utils } from '@/app/infrastructures/misc'
import { Courier } from '@/domain/entities/Courier'
import { MAX_NAME_WHITE_SELLER, MAX_PHONE_NUMBER_WHITE_SELLER } from '@/app/infrastructures/misc/Constants/validation'
import MarketplaceInputPhone from '../../components/MarketplaceInputPhone/index.vue'
import MarketplaceRadioButton from '../../components/MarketplaceRadioButton/index.vue'
import { PODTrackerDriver } from '@/domain/entities/PODTracker'

interface OptionsString {
  label: string
  value: string
}

interface OptionsNumber {
  label: string
  value: number
}

interface IValidations {
  form: {
    sellerName: {
      required: () => ValidationRule
      maxLength: ValidationRule
    }
    sellerPhone: {
      required: () => ValidationRule
      maxLength: () => boolean,
      minLength: () => boolean
    }
    status: {
      required: () => ValidationRule
    }
    agentId: {
      required: ValidationRule
    }
    sellerRole: {
      required: () => ValidationRule
    }
    courierId: {
      required: ValidationRule
    }
    assignType: {
      required: ValidationRule
    }
  }
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    MarketplaceTextInput,
    MarketplaceDropdown,
    ModalConfirm,
    ModalAlreadyRegister,
    ModalSuccess,
    ModalCourierNotFound,
    MarketplaceInputPhone,
    MarketplaceRadioButton
  },
})
export default class AddSellerWhitelist extends Vue {
  WhiteSellerController = WhiteSellerController
  POSController = POSController
  PODController = PODController
  modalCreateConfirm = false
  modalAlreadyRegister = false
  modalSuccessAdd = false
  modalCRRNFD = false
  statusOptions = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]
  sellerRoleOptions = [
    { label: 'TOKOPEDIA', value: 'TOKOPEDIA' },
    { label: 'BUKALAPAK', value: 'BUKALAPAK' },
    { label: 'MERCHANT', value: 'MERCHANT' },
    { label: 'CLIENT', value: 'CLIENT' },
  ]
  codHandlingOptions = [
    {
      label: 'specialcod',
      value: 'specialcod'
    },
    {
      label: 'standardcod',
      value: 'standardcod'
    }
  ]
  partnerPOSOptions = <OptionsNumber[]>([])
  driverListOptions = <OptionsString[]>([])
  form = {
    sellerName: '',
    sellerPhone: '',
    status: this.statusOptions[0],
    agentId: [] as Record<string, any>,
    sellerRole: [] as Record<string, any>,
    codHandling: [] as Record<string, any>,
    phoneCode: '+62',
    assignTo: 'pos',
    courierId: '' as any,
    assignType: '' as any
  }
  parameters = {
    page: 1,
    per_page: 100,
    search: '',
    sort_by: 'ASC',
    filter_status: 'ACTIVE'
  }
  courierParameters = {
    page: 1,
    per_page: 100,
    q: '',
    sort_by: 'ASC',
    courier_status: 'ACTIVE',
    driver_type: ''
  }
  isStatusActive = true
  MAX_PHONE_NUMBER_WHITE_SELLER = MAX_PHONE_NUMBER_WHITE_SELLER
  MAX_NAME_WHITE_SELLER = MAX_NAME_WHITE_SELLER
  assignToOptions = [
    { label: 'POS', value: 'pos' },
    { label: 'Kurir', value: 'courier' }
  ]

  created(): void {
    POSController.getPOSData(this.parameters)
    PODController.getDriverList(this.courierParameters)
  }

  get myAccessMenus(): string[] {
    return JSON.parse(
      LocalStorage.getLocalStorage(LocalStorage.ACCESS_MENU, true)
    )
  }

  get showCODHandlingDropdown(): boolean {
    return this.form.sellerRole.value === 'CLIENT'
  }

  get showPartnerPos(): boolean {
    return this.form.assignTo === 'pos'
  }

  private onSelectStatus(status: OptionsString) {
    if (status.value === 'ACTIVE') {
      this.isStatusActive = true
    } else {
      this.isStatusActive = false
    }
  }

  private onSearchPartnerPOS = Utils.debounce((keyword: string) => {
    const params = {
      ...this.parameters,
      search: keyword
    }
    POSController.getPOSData(params)
  }, 500)

  private onSelectPartnerPOS(pos: OptionsNumber) {
    if (pos) POSController.getCourierList(String(pos.value))
  }

  private handleNewCourier() {
    if (this.myAccessMenus && this.myAccessMenus.includes("manage-courier")) {
      let routeData = this.$router.resolve({ name: 'CreateManageCourierPage' })
      window.open(routeData.href, '_blank')
    } else {
      this.$notify({
        title: 'Forbidden Access',
        text: 'Please request access to admin',
        type: 'error',
        duration: 3000,
      })
      this.modalCRRNFD = false
    }
  }

  private onBackToList() {
    this.$router.push({ name: 'ManageWhitelist' })
  }

  private onSubmit() {
    if (this.form.status && this.form.sellerRole) {
      const payload = {
        sellerName: this.form.sellerName,
        sellerPhone: `${this.form.phoneCode}${this.form.sellerPhone}`,
        status: this.form.status.value,
        agentId: this.form.agentId.value && [this.form.agentId.value],
        sellerRole: this.form.sellerRole.value,
        codHandling: this.form.codHandling?.value,
        courierId: Number(this.form.courierId.value || 0) as any,
        assignType: this.form.assignType.value as any
      }

      if (this.form.sellerRole.value !== 'CLIENT') {
        delete payload.codHandling
      }

      if (this.showPartnerPos) {
        delete payload.assignType
        delete payload.courierId
      } else {
        delete payload.agentId
      }

      WhiteSellerController.create(payload)
    }
  }

  private onPhoneCodeChange(phoneCode: string) {
    this.form.phoneCode = phoneCode
  }

  private maxLengthIndonesianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.sellerPhone.length <= 13
    }
    return true
  }

  private minLengthIndosianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.sellerPhone.length >= 9
    }
    return true
  }
  private onSearchDriverList = Utils.debounce((keyword: string) => {
    const params = {
      ...this.courierParameters,
      q: this.replacePhoneNumber(keyword || '')
    }
    this.PODController.getDriverList(params)
  }, 500)

  private replacePhoneNumber(text: string): string {
    if (/^08([0-9]+)$/.test(text)) {
      return Utils.countryIndonesiaPhoneNumber(text).trim()
    }

    return text
  }

  get assignTypeOptions(): OptionsString[] {
    const items = [
      { label: 'Offer', value: 'OFFER' },
      { label: 'Auto Assign', value: 'AUTO ASSIGN' }
    ]
    return items
  }

  private onChangeAssignTo() {
    this.form.courierId = "";
    this.form.assignType = "";
    this.form.agentId = [];
  }

  @Validations()
  validations(): IValidations {
    const isPosOrCourierRequired = this.isStatusActive
    const isAssignToPos = this.showPartnerPos
    return {
      form: {
        sellerName: {
          required,
          maxLength: maxLength(MAX_NAME_WHITE_SELLER)
        },
        sellerPhone: {
          required,
          maxLength: this.maxLengthIndonesianPhoneNumber,
          minLength: this.minLengthIndosianPhoneNumber
        },
        status: { required },
        agentId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && isAssignToPos
          })
        },
        sellerRole: { required },
        courierId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
        assignType: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
      },
    }
  }

  @Watch('POSController.posData')
  setPOSPartner(data: POS[]): void {
    const POSOptions = data.map(item => {
      return {
        label: `${item.name} [${item.code}]`,
        value: item.id
      }
    }) as OptionsNumber[]
    this.partnerPOSOptions = POSOptions
  }

  @Watch('POSController.posCourier')
  setPOSCourier(data: Courier[]): void {
    if (data && data.length === 0) {
      this.form.agentId = []
      this.modalCRRNFD = true
    }
  }

  @Watch('WhiteSellerController.isAddWhiteSellerSuccess')
  setAddWhiteSellerSuccess(data: boolean): void {
    this.modalCreateConfirm = false
    this.modalSuccessAdd = data
    if (!data) this.modalAlreadyRegister = true
  }

  @Watch('form.sellerName')
  setSellerName(data: string): void {
    // remove script tag
    this.form.sellerName = Utils.removeScriptTags(data)

    // remove special character
    this.form.sellerName = Utils.removeSpecialCharacters(this.form.sellerName)

    // remove html tag
    this.form.sellerName = Utils.removeHTMLTags(this.form.sellerName)
  }

  @Watch('PODController.driverData')
  setDriverList(data: PODTrackerDriver[]): void {
    const DriverOption = data.map(item => {
      const label = `[${item.courierId}] ${item.fullname} (${item.announcementCourierType}) ${item.phoneNumber} • ${item.partnerName}`
      return {
        label,
        value: item.courierId?.toString()
      }
    }) as OptionsString[]
    this.driverListOptions = DriverOption
  }

  beforeDestroy(): void {
    WhiteSellerController.setIsAddWhiteSellerSuccess(false)
  }
}
